import {useMediaQuery} from "@mui/material";
import {UNSAFE_NavigationContext as NavigationContext} from "react-router-dom";
import {useCallback, useContext, useEffect} from "react";
import {DateTime} from "luxon";
import {useSelector} from "react-redux";
import {getActiveContestTranslationCategory, getContestCorrectAnswers} from "modules/selectors";
import {useTranslation} from "react-i18next";

export const useIsMobile = (query?: string) => {
	const isMobile = useMediaQuery(query || "(max-width: 1000px)");
	const isMobileShare = "share" in navigator && isMobile;

	return {isMobileShare, isMobile};
};

export const useGenerateShareMessage = () => {
	const {t} = useTranslation();
	const score = useSelector(getContestCorrectAnswers) ?? 0;
	const category = useSelector(getActiveContestTranslationCategory);
	const categoryTranslated = t(category);
	const date = DateTime.now().toFormat("LL/dd");

	return `MLB By The Numbers ${date}:\nCategory: ${categoryTranslated}\nScore: ${score}\n`;
};

function useConfirmExit(confirmExit: () => boolean, when = true) {
	const {navigator} = useContext(NavigationContext);

	useEffect(() => {
		if (!when) {
			return;
		}

		// eslint-disable-next-line @typescript-eslint/unbound-method
		const push = navigator.push;

		navigator.push = (...args: Parameters<typeof push>) => {
			const result = confirmExit();
			if (result) {
				push(...args);
			}
		};

		return () => {
			navigator.push = push;
		};
	}, [navigator, confirmExit, when]);
}

export function usePrompt(message: string, when = true) {
	useEffect(() => {
		if (when) {
			window.onbeforeunload = function () {
				return message;
			};
		}

		return () => {
			window.onbeforeunload = null;
		};
	}, [message, when]);

	const confirmExit = useCallback(() => {
		return window.confirm(message);
	}, [message]);
	useConfirmExit(confirmExit, when);
}
